import React from 'react';
import { AccountListContent } from '@/experiences/sales-portal/domain/accounts/screens/account-list/containers/account-list-content';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesHubShellTemplate } from '@/experiences/sales-portal/templates/sales-hub-shell-template';
import { SalesPortalAccountsStackParams } from '@/navigators/types';
import { StackScreenProps } from '@react-navigation/stack';

type Props = StackScreenProps<
  SalesPortalAccountsStackParams,
  typeof SALES_PORTAL_ROUTES.AccountList
>;

export const AccountListScreen: React.FC<Props> = () => (
  <SalesHubShellTemplate>
    <AccountListContent />
  </SalesHubShellTemplate>
);
